module.exports = __webpack_public_path__ + "static/media/pencil-regular1.3407d26d.svg";